import { render } from "./Starting.vue?vue&type=template&id=4f261a06&scoped=true"
import script from "./Starting.vue?vue&type=script&lang=js"
export * from "./Starting.vue?vue&type=script&lang=js"

import "./Starting.vue?vue&type=style&index=0&id=4f261a06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f261a06"]])

export default __exports__